<template>
  <section class="home-prototype-page">
    <div class="home-prototype-title">
      <h1>岗位能力类方向老师<br>成绩查询</h1>
    </div>

    <div class="home-prototype-card">
      <form class="home-prototype-form" @submit.prevent="submitLogin">
        <div class="home-prototype-form__group">
          <label class="home-prototype-label" for="studentName">老师姓名</label>
          <input
            id="studentName"
            v-model.trim="loginForm.name"
            class="home-prototype-input"
            type="text"
            maxlength="20"
            placeholder="请输入老师姓名"
          >
        </div>
        <div class="home-prototype-form__group">
          <label class="home-prototype-label" for="idNumber">身份证号</label>
          <input
            id="idNumber"
            v-model.trim="loginForm.idCard"
            class="home-prototype-input"
            type="text"
            maxlength="18"
            placeholder="输入18位身份证号"
          >
        </div>
        <div v-if="loginError" class="status-text status-text--error home-prototype-error">{{ loginError }}</div>
        <div class="home-prototype-form__action">
          <span class="home-prototype-label home-prototype-label--placeholder" />
          <button class="home-prototype-submit" type="submit" :disabled="loginLoading">
            {{ loginLoading ? '查询中...' : '查询' }}
          </button>
        </div>
      </form>
    </div>

    <div class="home-prototype-notice">
      <div class="home-prototype-notice__title">注意事项：</div>
      <div>1.请输入正确的老师姓名和身份证号登录系统查询本人岗位能力成绩。</div>
      <div>2.本系统成绩查询服务仅供本人核验成绩使用。</div>
  
      <div>3.成绩查询若无法正常显示，可能是系统忙，请避开高峰期查询。</div>
    </div>
  </section>
</template>
<script>
import { fetchPostAbilityScoreList, loginWithPostAbilityCandidate } from '@/api/portal'
import { setScopedSession } from '@/utils/auth'

export default {
  name: 'HomePage',
  data() {
    return {
      loginForm: {
        name: '',
        idCard: ''
      },
      loginLoading: false,
      loginError: ''
    }
  },
  methods: {
    async resolveDefaultRedirect() {
      const records = await fetchPostAbilityScoreList()
      if (!records.length) {
        throw new Error('未查询到岗位能力成绩记录')
      }
      return `/post-ability/scores/${records[0].candidateId}`
    },
    async submitLogin() {
      this.loginError = ''

      if (!this.loginForm.name) {
        this.loginError = '请输入老师姓名'
        return
      }

      if (!this.loginForm.idCard) {
        this.loginError = '请输入身份证号'
        return
      }

      this.loginLoading = true

      try {
        const response = await loginWithPostAbilityCandidate(this.loginForm)
        const session = {
          ...response,
          profile: {
            ...(response.profile || {}),
            candidateName: (response.profile && response.profile.candidateName) || this.loginForm.name,
            idCard: (response.profile && response.profile.idCard) || this.loginForm.idCard
          }
        }

        setScopedSession(session, 'postAbility')
        let redirectPath = this.$route.query.redirect
        if (!redirectPath) {
          redirectPath = await this.resolveDefaultRedirect()
        }
        this.$router.push(redirectPath)
      } catch (error) {
        this.loginError = error.message || '登录失败，请稍后重试'
      } finally {
        this.loginLoading = false
      }
    }
  }
}
</script>
